import * as z from "zod";
import { WebhookBasicSchema } from "./base";

export const ListWebhooksResponseSchema = z.array(WebhookBasicSchema);

export type ListWebhooksResponse = z.infer<typeof ListWebhooksResponseSchema>;
